(function () {
  // DISABLED Nov 2026: replaced by the Shopify Forms email popup (HELLO10).
  // To turn the quiz back on, set QUIZ_ENABLED = true.
  var QUIZ_ENABLED = false;
  if (!QUIZ_ENABLED) return;

  var STORAGE_KEY = 'velora_quiz_last_shown';
  var SHOW_AGAIN_AFTER_MS = 1000 * 60 * 60 * 24 * 3; // 3 days
  var SHOW_DELAY_MS = 15000;   // wait 15s so shoppers see the store first
  var SCROLL_TRIGGER = 0.5;    // ...or once they scroll halfway down

  function init() {
    var overlay = document.getElementById('velora-quiz-popup-overlay');
    if (!overlay) return;

    var questionScreen = overlay.querySelector('[data-screen="question"]');
    var resultScreen = overlay.querySelector('[data-screen="result"]');
    var resultTitle = overlay.querySelector('.velora-quiz-result-title');
    var resultBody = overlay.querySelector('.velora-quiz-result-body');
    var resultCta = overlay.querySelector('.velora-quiz-cta');
    var opened = false;

    function shouldShow() {
      try {
        var last = window.localStorage.getItem(STORAGE_KEY);
        if (!last) return true;
        return Date.now() - parseInt(last, 10) > SHOW_AGAIN_AFTER_MS;
      } catch (e) { return true; }
    }
    function markShown() {
      try { window.localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }
    function openPopup() {
      if (opened) return;
      opened = true;
      window.removeEventListener('scroll', onScroll);
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
      markShown();
    }
    function closePopup() {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 250);
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= SCROLL_TRIGGER) openPopup();
    }

    overlay.querySelectorAll('.velora-quiz-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url') || '/collections/all';
        resultTitle.textContent = btn.getAttribute('data-title') || '';
        resultBody.textContent = btn.getAttribute('data-body') || '';
        resultCta.textContent = btn.getAttribute('data-cta') || 'Shop Now';
        resultCta.setAttribute('href', '/discount/VELORA10?redirect=' + encodeURIComponent(url));
        questionScreen.hidden = true;
        resultScreen.hidden = false;
      });
    });

    var closeBtn = overlay.querySelector('.velora-quiz-close');
    var skipBtn = overlay.querySelector('.velora-quiz-skip');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (skipBtn) skipBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closePopup(); });

    if (shouldShow()) {
      setTimeout(openPopup, SHOW_DELAY_MS);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
